import { ventasConsultivas45 } from "./ventas-consultivas-45";
import { decidirIncertidumbre15 } from "./decidir-incertidumbre-15";
import { gestionStartupsAgil45 } from "./gestion-startups-agil-45";

export const programs = [decidirIncertidumbre15, ventasConsultivas45, gestionStartupsAgil45];

export function getProgramBySlug(slug) {
  return programs.find((p) => p.slug === slug) || null;
}
